import React, {useRef, useEffect, useMemo} from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.scss";

export default function Modal(props) {
  const {
    id,
    variant = "sidebar",
    children,
    className = "",
    usePortal = true,
    onClose = null,
    staticModal = false,
    hideBackdrop = false,
    ...rest
  } = props;
  const target = useRef(document.body);
  const modalRef = useRef(null);

  const observer = useMemo(
    () =>
      new MutationObserver(mutation => {
        const hasShowClass = mutation[0].target.classList.contains("show");

        if (hasShowClass) {
          const allBackdrops = document.body.querySelectorAll(".modal-backdrop.show").length;

          if (allBackdrops > 1) {
            document.body.querySelectorAll(".modal-backdrop.show")[allBackdrops - 1].remove();
          }
        }

        if (!hasShowClass) {
          onClose && onClose();
        }
      }),
    [onClose],
  );

  useEffect(() => {
    onClose &&
      modalRef.current &&
      observer.observe(modalRef.current, {
        attributes: true,
        attributeFilter: ["class"],
      });

    return () => {
      observer.disconnect();
    };
  }, [onClose, observer]);

  if (usePortal) {
    return ReactDOM.createPortal(
      <div
        className={`modal ${variant === "bottom" ? "fade" : ""} ${styles.modal} ${className}`}
        id={id}
        ref={modalRef}
        variant={variant}
        tabIndex="-1"
        aria-labelledby={`${id}Label`}
        aria-hidden="true"
        data-bs-backdrop={hideBackdrop ? false : staticModal ? "static" : true}>
        <div className={`modal-dialog ${variant === "bottom" ? "w-100" : ""}`}>
          <div className="modal-content">{children}</div>
        </div>
      </div>,
      target.current,
    );
  }

  return (
    <div
      className={`modal ${styles.modal} ${className}`}
      id={id}
      variant={variant}
      tabIndex="-1"
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
      data-bs-backdrop={staticModal ? "static" : true}>
      <div className="modal-dialog">
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}
